import type { SiteId } from '../types'

interface SiteMeta {
  id: SiteId
  name: string
  accent: string
}

const SITES: Record<SiteId, SiteMeta> = {
  h2o: { id: 'h2o', name: 'H2O', accent: '#0284c7' },
  poolspa: { id: 'poolspa', name: 'POOL SPA', accent: '#0891b2' },
  crwood: { id: 'crwood', name: 'C.R. Wood', accent: '#b45309' },
  velocity: { id: 'velocity', name: 'Velocity Web', accent: '#1e3a8a' },
  momentumsoftware: { id: 'momentumsoftware', name: 'Momentum Software', accent: '#6d28d9' },
  momentumwp: { id: 'momentumwp', name: 'Momentum WP', accent: '#2e57e5' },
  demo: { id: 'demo', name: 'Spoke & Sprocket', accent: '#0f766e' },
}

// Runtime names from the sites table — populated by registerSites() (SiteBadge
// keeps this fresh via the cached ['sites'] query) so NEW clients added via
// the PWA wizard get their real display name without a code change.
const runtime = new Map<string, SiteMeta>()

export function registerSites(rows: Array<{ id: string; name: string; primaryColor: string | null }>): void {
  for (const r of rows) {
    runtime.set(r.id, { id: r.id, name: r.name, accent: r.primaryColor || '#6b7280' })
  }
}

export function siteMeta(site: SiteId): SiteMeta {
  return runtime.get(site) ?? SITES[site] ?? { id: site, name: site, accent: '#6b7280' }
}
